import axios from 'axios';
import {
  SAP_AUDIT_STATS_LOADING,
  SAP_AUDIT_STATS_SUCCESS,
  SAP_AUDIT_STATS_ERROR,
  SAP_AUDIT_LOGS_LOADING,
  SAP_AUDIT_LOGS_SUCCESS,
  SAP_AUDIT_LOGS_ERROR,
  SAP_AUDIT_DETAIL_LOADING,
  SAP_AUDIT_DETAIL_SUCCESS,
  SAP_AUDIT_DETAIL_ERROR,
  SAP_AUDIT_DETAIL_CLEAR,
  SAP_AUDIT_SET_FILTERS,
  SAP_AUDIT_RESET_FILTERS,
  SAP_AUDIT_SET_PAGE,
  SAP_AUDIT_SET_PAGE_SIZE,
} from '../types';
import { appUrl } from "../../../../../utils/config"



const SAP_AUDIT_BASE_URL = appUrl;

export const fetchSapAuditStats = (payload) => (dispatch) => {
  dispatch({ type: SAP_AUDIT_STATS_LOADING, payload: true });

  axios.post(`${SAP_AUDIT_BASE_URL}/sapAudit/fetchStats`, payload)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: SAP_AUDIT_STATS_SUCCESS, payload: res.data.data });
      } else {
        dispatch({
          type: SAP_AUDIT_STATS_ERROR,
          payload: res.data.errorMessage || 'Failed to fetch stats',
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: SAP_AUDIT_STATS_ERROR,
        payload: err?.response?.data?.errorMessage || 'Network error',
      });
    })
    .finally(() => {
      dispatch({ type: SAP_AUDIT_STATS_LOADING, payload: false });
    });
};

export const fetchSapAuditLogs = (payload) => (dispatch) => {
  dispatch({ type: SAP_AUDIT_LOGS_LOADING, payload: true });

  axios.post(`${SAP_AUDIT_BASE_URL}/sapAudit/fetchLogs`, payload)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: SAP_AUDIT_LOGS_SUCCESS,
          payload: {
            logs: res.data.data.logs,
            total: res.data.data.total,
            page: res.data.data.page,
            pageSize: res.data.data.pageSize,
          },
        });
      } else {
        dispatch({
          type: SAP_AUDIT_LOGS_ERROR,
          payload: res.data.errorMessage || 'Failed to fetch logs',
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: SAP_AUDIT_LOGS_ERROR,
        payload: err?.response?.data?.errorMessage || 'Network error',
      });
    })
    .finally(() => {
      dispatch({ type: SAP_AUDIT_LOGS_LOADING, payload: false });
    });
};

export const fetchSapAuditDetail = (id) => (dispatch) => {
  dispatch({ type: SAP_AUDIT_DETAIL_LOADING, payload: true });

  axios.post(`${SAP_AUDIT_BASE_URL}/sapAudit/fetchDetail`, { id })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: SAP_AUDIT_DETAIL_SUCCESS, payload: res.data.data });
      } else {
        dispatch({
          type: SAP_AUDIT_DETAIL_ERROR,
          payload: res.data.errorMessage || 'Failed to fetch detail',
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: SAP_AUDIT_DETAIL_ERROR,
        payload: err?.response?.data?.errorMessage || 'Network error',
      });
    })
    .finally(() => {
      dispatch({ type: SAP_AUDIT_DETAIL_LOADING, payload: false });
    });
};

export const clearSapAuditDetail = () => (dispatch) => {
  dispatch({ type: SAP_AUDIT_DETAIL_CLEAR });
};

export const setSapAuditFilters = (filters) => (dispatch) => {
  dispatch({ type: SAP_AUDIT_SET_FILTERS, payload: filters });
};

export const resetSapAuditFilters = () => (dispatch) => {
  dispatch({ type: SAP_AUDIT_RESET_FILTERS });
};

export const setSapAuditPage = (page) => (dispatch) => {
  dispatch({ type: SAP_AUDIT_SET_PAGE, payload: page });
};

export const setSapAuditPageSize = (pageSize) => (dispatch) => {
  dispatch({ type: SAP_AUDIT_SET_PAGE_SIZE, payload: pageSize });
};
